// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1sQMv","content":"styles_content__FhXXI","row":"styles_row__17Cv-","footer":"styles_footer__3RKNH","phraseLength":"styles_phraseLength__3vXxW"};